import type { GridProps } from '@mui/material'
import { Grid } from '@mui/material'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

/**
 * A wrapper component for MUI's Grid component.
 * This component exists to isolate MUI Grid changes and make future migrations easier.
 *
 * @example
 * ```tsx
 * <SitelineGrid container spacing={2}>
 *   <SitelineGrid item xs={12}>
 *     Content
 *   </SitelineGrid>
 * </SitelineGrid>
 * ```
 */
export const SitelineGrid = forwardRef<HTMLDivElement, PropsWithChildren<GridProps>>(
  function SitelineGrid(props, ref) {
    return <Grid ref={ref} {...props} />
  }
)

SitelineGrid.displayName = 'SitelineGrid'
